import i18n from 'modules/core/lib/i18n'

export interface BenefitItem {
  id: string
  title: string
  description: string
  media: {
    src: string
    alt: string
  }
}

export interface FeatureItem {
  title: string
  subtitle: string
}

export interface BenefitsLandingContent {
  hero: {
    title: string
    subtitle: string
    media: {
      src: string
      alt: string
    }
    cta: string
  }
  mainMessage: {
    title: string
  }
  benefits: BenefitItem[]
  cta: {
    title: string
    buttonText: string
  }
  features: FeatureItem[]
}

const getContentByCountry = (countryCode: string): BenefitsLandingContent => {
  if (countryCode === 'es') {
    return {
      hero: {
        title: i18n.t('benefits.landing.es.hero.title'),
        subtitle: i18n.t('benefits.landing.es.hero.subtitle'),
        media: {
          src: 'https://stream.mux.com/EuB300ratRsTHAex5aXNQFsdeIZCVuUZQ/high.mp4', // in-app-hero.mp4
          alt: 'Benefits',
        },
        cta: i18n.t('benefits.landing.es.hero.cta'),
      },
      mainMessage: {
        title: i18n.t('benefits.landing.es.main_message.title'),
      },
      benefits: [
        {
          id: 'satisfaction',
          title: i18n.t('benefits.landing.es.benefits.satisfaction.title'),
          description: i18n.t('benefits.landing.es.benefits.satisfaction.description'),
          media: {
            src: 'https://stream.mux.com/tN00IiUwTF1tSKr7VVpDDje5R006VIFcKm/high.mp4', // in-app-employees.mp4
            alt: 'Benefits',
          },
        },
        {
          id: 'retention',
          title: i18n.t('benefits.landing.es.benefits.retention.title'),
          description: i18n.t('benefits.landing.es.benefits.retention.description'),
          media: {
            src: 'https://stream.mux.com/Bdy4BSTvYLGsqERQ4OlExCC2oD5bglK01/high.mp4', // in-app-talent.mp4
            alt: 'Benefits',
          },
        },
        {
          id: 'savings',
          title: i18n.t('benefits.landing.es.benefits.savings.title'),
          description: i18n.t('benefits.landing.es.benefits.savings.description'),
          media: {
            src: 'https://stream.mux.com/c00JYh5K4JUKaKcS6AsZAChQlGRzrzGtH/high.mp4', // in-app-one-card.mp4
            alt: 'Benefits',
          },
        },
      ],
      cta: {
        title: i18n.t('benefits.landing.es.cta.title'),
        buttonText: i18n.t('benefits.landing.es.cta.buttonText'),
      },
      features: [
        {
          title: i18n.t('benefits.landing.es.features.satisfaction.title'),
          subtitle: i18n.t('benefits.landing.es.features.satisfaction.subtitle'),
        },
        {
          title: i18n.t('benefits.landing.es.features.productivity.title'),
          subtitle: i18n.t('benefits.landing.es.features.productivity.subtitle'),
        },
        {
          title: i18n.t('benefits.landing.es.features.retention.title'),
          subtitle: i18n.t('benefits.landing.es.features.retention.subtitle'),
        },
      ],
    }
  }

  throw new Error(`Unsupported country code: ${countryCode}`)
}

/**
 * Get content for the benefits landing page based on country
 * In the future, this can be enhanced with proper country detection logic
 */
export const getBenefitsLandingContent = (countryCode = 'es'): BenefitsLandingContent => {
  return getContentByCountry(countryCode)
}
